export const currencyText = (value: number) => {
  return Math.trunc(value)
    .toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })
    .replace('￥', '¥')
}

export const pointText = (value: number) => {
  return Math.trunc(value).toLocaleString() + 'P'
}
